/*    
<summary>
  This functional component "RefundPopupHOC" provides props to the child component.
  1. State "showRefundPopup" that manages the show/hide of pop up
  2. Function "refundPopupToggleHandler" to toggle the show/hide popup state "showRefundPopup"
  Developer:Mohammad Saquib Khan, Created Date:04-April-2024
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const RefundPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showRefundPopup,setShowRefundPopup] = useState<boolean>(false);

    const refundToggleHandler = () => {
        setShowRefundPopup(!showRefundPopup);
    }
	
	return <Component showRefundPopup={showRefundPopup} refundPopupToggleHandler={refundToggleHandler} {...props}/>;
};

export default RefundPopupHOC;   